import { type LocaleCode } from 'contentful';

import {
    isTypeBanner,
    isTypeBlockArticles,
    isTypeBlockContent,
    isTypeBlockCta,
    isTypeBlockFaq,
    isTypeBlockLegalText,
    isTypeBlockProducts,
    isTypeBlockPromo,
    isTypeBlockQuickLink,
    isTypeBlockText,
    isTypeBlockValuePrompt,
    isTypeBlockWidget,
    isTypeBlogArticle,
    isTypeBlogAuthor,
    isTypeBlogCategory,
    isTypeBlogSection,
    isTypeBlogTag,
    isTypeLanding,
    isTypeLayout,
    isTypeLeadForm,
    isTypeNotificationBanner,
} from '../models/Generated';

export const isContentItemBanner = isTypeBanner<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockContent = isTypeBlockContent<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockProducts = isTypeBlockProducts<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockPromo = isTypeBlockPromo<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockQuickLink = isTypeBlockQuickLink<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockText = isTypeBlockText<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockValuePrompt = isTypeBlockValuePrompt<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockWidget = isTypeBlockWidget<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemLayout = isTypeLayout<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemNotificationBanner = isTypeNotificationBanner<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockFaq = isTypeBlockFaq<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockArticles = isTypeBlockArticles<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockCta = isTypeBlockCta<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlockLegalText = isTypeBlockLegalText<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemLeadForm = isTypeLeadForm<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlogSection = isTypeBlogSection<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlogTag = isTypeBlogTag<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlogArticle = isTypeBlogArticle<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlogCategory = isTypeBlogCategory<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemBlogAuthor = isTypeBlogAuthor<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;

export const isContentItemLanding = isTypeLanding<'WITHOUT_UNRESOLVABLE_LINKS', LocaleCode>;
